import React from 'react';
import background from '../../assets/lobster.jpg';
import ReusableInfoCard from '../../components/ReusableInfoCard/ReusableInfoCard';


class InfoAquaticlife extends React.Component {
  render () { 
   return(
  
  <ReusableInfoCard             
    
        tag="OCEANS"
        description="Aquatic Life"
        paragraph="The diverse and inter-dependent ecosystems found in our oceans, coasts, and estuaries are essential to all terrestrial life (NOAA)."
        background={background}
     />
  
  );
 }
}   

export default InfoAquaticlife;